<template>
  <div>素材中心</div>
</template>

<script>
export default {
  name: 'statistics',
};
</script>

<style lang="less">
</style>
